/* Problem/solution section: CTA straight to checkout, light heading text animation, pause loops off-screen */
(function () {
  var d = document, w = window;
  var calm = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = w.Shopify && w.Shopify.designMode;
  var hasIO = 'IntersectionObserver' in w;
  var spin = '<span class="bcps-go__spin" aria-hidden="true"></span>';

  d.querySelectorAll('[id^="bc-ps-"]').forEach(function (root) {
    /* 1. "Get all 8 books" -> the bundle straight into checkout */
    var cta = root.querySelector('[data-bcps-cta]');
    if (cta) {
      var btn = cta.cloneNode(true);           /* drops the old scroll-only handler */
      cta.parentNode.replaceChild(btn, cta);
      btn.classList.add('bcps-go');
      btn.insertAdjacentHTML('beforeend', spin);
      var href = btn.getAttribute('href') || '';
      if (href === '#MainContent' || href === '#' || href === '') {
        var idInput = d.querySelector('form[action*="/cart/add"] [name="id"]');
        if (idInput && idInput.value) btn.setAttribute('href', '/cart/' + idInput.value + ':1');
      }
      btn.addEventListener('click', function (e) {
        var to = btn.getAttribute('href') || '';
        if (to.charAt(0) === '#') {
          var t = d.querySelector('.bc-buybox, form[action*="/cart/add"]');
          if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          return;
        }
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        /* keep quantity chosen in the buy box, if any */
        var q = d.querySelector('.bc-buybox [name="quantity"], form[action*="/cart/add"] [name="quantity"]');
        var qty = q && parseInt(q.value, 10) > 1 ? parseInt(q.value, 10) : 1;
        to = to.replace(/:(\d+)$/, ':' + qty);
        btn.classList.add('is-loading');
        setTimeout(function () { w.location.href = to; }, 280);
      });
      w.addEventListener('pageshow', function () { btn.classList.remove('is-loading'); });
    }

    /* 2. Heading: words rise in one after another (light) */
    var head = root.querySelector('.bcps-head');
    var h2 = head && head.querySelector('.bc-h2');
    if (h2 && !calm && !design && hasIO) {
      var i = 0;
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (c) {
          if (c.nodeType === 3) {
            var frag = d.createDocumentFragment();
            c.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(d.createTextNode(part)); return; }
              var sp = d.createElement('span');
              sp.className = 'bcps-w'; sp.style.setProperty('--w', i++); sp.textContent = part;
              frag.appendChild(sp);
            });
            c.parentNode.replaceChild(frag, c);
          } else if (c.nodeType === 1 && c.tagName === 'EM') {
            c.classList.add('bcps-w', 'bcps-w--em'); c.style.setProperty('--w', i++);
          } else if (c.nodeType === 1) { walk(c); }
        });
      })(h2);
      head.setAttribute('data-bc-anim', 'own'); /* site-wide reveal skips it */
      root.classList.add('bcps-js');
      var hio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { head.classList.add('is-in'); hio.disconnect(); } });
      }, { threshold: 0.3 });
      hio.observe(head);
      setTimeout(function () { head.classList.add('is-in'); }, 6000);
    }

    /* 3. Pause decorative loops while off-screen (keeps scrolling smooth & fast) */
    var show = root.querySelector('[data-bcps-show]');
    if (show && hasIO) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { show.classList.toggle('is-paused', !e.isIntersecting); });
      }).observe(show);
    }
  });
})();
